<div class="vwui-alert is-warning mb-4" *ngIf="message">
    <app-icon iconName="oval-exclamation"></app-icon>
    {{ message }}
</div>
